module.exports = __webpack_public_path__ + "img/yiwen.374f0931.png";